/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
export class RequestResponse {
    itemId: number;
    subject: string;
    location: string;
    contactType: number;
    contactEmail: string;
    contactPhone: string;
    contactTime: number;
    contactTimePeriod: number;
    requestDescription: string;
    customFields: (CustomFieldRequest)[] | null;
    requestProcessIndex: RequestProcessIndex;
    classfication: number;
    requestPriority: number;
    formSubmission: string;
    urgencyTypeId: number;
    priorityTypeId: number;
    customerCC: string;
}
export class CustomFieldRequest {
    fieldId: number;
    fieldValue: string;
}

export class IncidentFileUpload {
    files: Array<File>;
    requestId: number;
}

export enum RequestProcessIndex {
    INCIDENT, CHANGE, SERVICE
}
